import { BannerData, BannerDataResponse } from '../types/common.type';
import { GET_MEDIA_URL, IMAGE_URL_PREFIX } from '../utils/environment';
import axiosInstance from '../utils/axiosInstance';

class CommonServices {
  static async getBannerImagesAsync(
    token: string,
    cat: 'BANNER' | 'TESTIMONIAL',
    type: 'HOMESCREEN' | 'CAROUSEL' | 'VIDEO',
  ): Promise<BannerData[]> {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    try {
      const res = await axiosInstance.get(GET_MEDIA_URL(cat, type), config);
      const responseData = res?.data as BannerDataResponse;
      if (responseData?.stat && responseData?.imageDetails) {
        return responseData.imageDetails?.map((i) => ({
          ...i,
          imgUrl: IMAGE_URL_PREFIX + i.imgUrl,
        }));
      }
      return [];
    } catch (error) {
      console.log('Error in getBannerImagesAsync: ', error);
      return [];
    }
  }
}

export default CommonServices;